import URL from './urls'
import APICRUD from './apiCrud'
import { transformToISONumber } from './events'
export class Users extends APICRUD {
  /*http() {
    console.log(localStorage.getItem('token'))
    return Axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        Accept: 'application/Json'
      }
    })
  }*/
  save(data) {
    return this.http().post(`${URL.USERS_URL}/create`, {
      ...data,
      phone: transformToISONumber(data.phone),
      timezone:
        typeof data.timezone == 'string' ? data.timezone : data.timezone.value
    })
  }
  update(data) {
    return this.http().post(`${URL.USERS_URL}/update`, {
      ...data,
      phone: transformToISONumber(data.phone),
      timezone:
        typeof data.timezone == 'string' ? data.timezone : data.timezone.value
    })
  }
  index(options) {
    return this.http().get(`${URL.USERS_URL}/index`, {
      params: {
        ...options,
        per_page: options.perPage,
        order_by: options.orderBy,
        order_flow: options.orderFlow
      }
    })
  }

  getSettings(userId) {
    console.log(userId)
    return this.http().post(`${URL.USERS_SETTINGS_URL}`, {
      user_id: userId
    })
  }

  getUserRates(id, options) {
    return this.http().get(`${URL.USERS_URL}/${id}/rates`, { params: options })
  }
}

export default new Users()
